var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ErrorBoundary } from '@alife/simple-ui';
import { CardTypeMap, CardDefault, CardTypeName } from './card-map';
export { CardTypeCode, TemplateTypeCode, registerCard, registerTemplate } from './card-map';
export { CardTypeName };
function getMessageCard(TypeMap) {
    return function MessageCard(props) {
        var cardType = +props.cardType;
        var RenderCard = TypeMap.get(cardType) || CardDefault;
        var cardName = CardTypeName[cardType] || 'unknow';
        return (React.createElement("div", { className: "lzd-message-item " + cardName },
            React.createElement(ErrorBoundary, { ErrorComponent: CardDefault },
                React.createElement(RenderCard, __assign({}, props)))));
    };
}
var MessageCard = getMessageCard(CardTypeMap);
export var getCardMap = function () { return CardTypeMap; };
export default MessageCard;

//# sourceMappingURL=index.js.map
